import { render } from "./ProtocoloComponent.vue?vue&type=template&id=42d1e330&scoped=true"
import script from "./ProtocoloComponent.vue?vue&type=script&lang=js"
export * from "./ProtocoloComponent.vue?vue&type=script&lang=js"

import "./ProtocoloComponent.vue?vue&type=style&index=0&id=42d1e330&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d1e330"]])

export default __exports__